import { useEffect, useState } from "react";
import AirplanemodeActiveOutlinedIcon from "@mui/icons-material/AirplanemodeActiveOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DirectionsCarOutlinedIcon from "@mui/icons-material/DirectionsCarOutlined";
import GolfCourseIcon from "@mui/icons-material/GolfCourse";
import HotelOutlinedIcon from "@mui/icons-material/HotelOutlined";
import LocalDiningOutlinedIcon from "@mui/icons-material/LocalDiningOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import { Link } from "react-router-dom";
import {
  courseGallery,
  destinations,
  itineraries,
  kakaoInquiryUrl,
  phoneUrl,
  reviews,
} from "../../data/specialTour";
import {
  ContentBand,
  Inner,
  KakaoButton,
  QuickContactBar,
  SectionHeader,
  SpecialTourLayout,
} from "./SpecialTourLayout";

const estimateSamplePdf = "/special-tour-assets/hokkaido-obihiro-3n4d-72hole-sample-2026.pdf";

const eliteHeroSlides = [
  {
    src: "/special-tour-assets/elite-golf-life-hero.jpg",
    alt: "클럽하우스 앞 티 위에 놓인 골프공",
  },
  {
    src: "/special-tour-assets/elite-golf-life-hero-morning.png",
    alt: "새벽 안개가 깔린 골프장 그린",
  },
  {
    src: "/special-tour-assets/elite-golf-life-hero-coastal.png",
    alt: "해안 절벽 골프 코스에서 스윙하는 골퍼",
  },
  {
    src: "/special-tour-assets/elite-golf-life-hero-champion.png",
    alt: "갤러리 앞 그린에서 주먹을 들어 올린 골퍼",
  },
];

const productImages = [
  {
    src: "/special-tour-assets/hokkaido-classic-course.png",
    alt: "홋카이도 클래식 골프 코스",
    label: "홋카이도",
  },
  {
    src: "/special-tour-assets/osaka-area-map.png",
    alt: "오사카 주변 골프장 지도",
    label: "오사카",
  },
  {
    src: "/special-tour-assets/shikoku-matsuyama-dogo.jpg",
    alt: "마쓰야마 도고온천과 시코쿠 골프 여행",
    label: "시코쿠",
  },
  {
    src: "/special-tour-assets/kagoshima-area-map.png",
    alt: "가고시마 골프장 지도",
    label: "큐슈",
  },
  {
    src: "/special-tour-assets/okinawa-naha-map.png",
    alt: "오키나와 골프장 지도",
    label: "오키나와",
  },
];

const productFacts = [
  { label: "국가", value: "일본", icon: <MapOutlinedIcon /> },
  { label: "일정", value: "3박 4일 기준", icon: <CalendarMonthOutlinedIcon /> },
  { label: "라운드", value: "54홀 맞춤", icon: <GolfCourseIcon /> },
  { label: "항공", value: "항공 별도", icon: <AirplanemodeActiveOutlinedIcon /> },
];

const includedItems = [
  "지역별 골프장 섭외 및 라운드 구성",
  "호텔, 차량, 가이드 동선 상담",
  "골프 + 자유여행 맞춤 일정 설계",
  "현지 식당, 온천, 관광지 추천",
  "카카오톡 1:1 상담",
];

const excludedItems = [
  "왕복 항공권",
  "개인 식사 및 자유 일정 비용",
  "캐디피, 캐디팁, 개인 렌탈 비용",
  "일정 외 개인 경비",
];

const noticeItems = [
  "최종 견적은 출발일, 인원, 항공 시간, 희망 골프장에 따라 달라집니다.",
  "우천, 적설, 현지 골프장 휴장 여부에 따라 라운드 운영 조건이 바뀔 수 있습니다.",
  "단체팀은 골프조와 자유여행조를 나누어 별도 동선으로 상담할 수 있습니다.",
  "영상 원본은 대용량이라 홈페이지에는 안내 카드로만 정리했습니다.",
];

const tabs = [
  { label: "일정표", href: "#schedule" },
  { label: "상세정보", href: "#details" },
  { label: "골프장소개", href: "#courses" },
  { label: "호텔&여행", href: "#stay" },
  { label: "후기/문의", href: "#reviews" },
];

function DetailTitle() {
  return (
    <div className="border-b border-[#d9ded5] pb-5">
      <div className="mb-3 flex flex-wrap gap-2">
        <span className="rounded-lg bg-[#e8f2e6] px-3 py-1 text-xs font-900 text-[#1d5d31]">일본골프</span>
        <span className="rounded-lg bg-[#fff4dc] px-3 py-1 text-xs font-900 text-[#b45d13]">맞춤투어</span>
        <span className="rounded-lg bg-[#f0f1f4] px-3 py-1 text-xs font-900 text-[#526054]">항공별도</span>
      </div>
      <h1 className="text-3xl font-900 leading-tight text-[#15391f] md:text-4xl">
        [스페셜투어]일본골프맞춤여행
      </h1>
      <p className="mt-4 text-base leading-8 text-[#596559]">
        스페셜투어는 가격표대로 파는 여행이 아니라, 각자 팀 일정에 맞춰 일본 지역별 골프와 자유여행 동선을
        맞춤 설계합니다.
      </p>
    </div>
  );
}

function ProductSummary() {
  return (
    <aside className="rounded-lg border border-[#d9ded5] bg-white p-5 shadow-sm lg:sticky lg:top-24">
      <DetailTitle />
      <div className="grid gap-4 py-5">
        <div className="flex items-end justify-between border-b border-[#edf0ea] pb-4">
          <span className="text-sm font-800 text-[#697469]">상품가</span>
          <span className="text-3xl font-900 text-[#d16339]">맞춤견적</span>
        </div>
        <div className="grid gap-3 text-sm">
          {[
            ["추천지역", "홋카이도 · 오사카 · 시코쿠 · 큐슈 · 오키나와"],
            ["기본일정", "3박 4일 54홀 기준"],
            ["진행방식", "카카오톡 상담 후 맞춤 설계"],
            ["여행형태", "골프 전용 / 골프 + 자유여행"],
          ].map(([label, value]) => (
            <div key={label} className="grid grid-cols-[90px_1fr] gap-3">
              <span className="font-900 text-[#15391f]">{label}</span>
              <span className="leading-6 text-[#596559]">{value}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="grid gap-3">
        <a
          href={kakaoInquiryUrl}
          className="inline-flex min-h-12 items-center justify-center gap-2 rounded-lg bg-[#FEE500] px-5 text-sm font-900 text-[#1b1600] transition hover:bg-[#f3db00]"
        >
          <ChatBubbleOutlineIcon sx={{ fontSize: 20 }} />
          카카오톡 견적문의
        </a>
        <a
          href={estimateSamplePdf}
          target="_blank"
          rel="noreferrer"
          className="inline-flex min-h-12 items-center justify-center gap-2 rounded-lg border border-[#c9d3c5] bg-white px-5 text-sm font-900 text-[#15391f] transition hover:border-[#8faa87]"
        >
          <PictureAsPdfOutlinedIcon sx={{ fontSize: 19 }} />
          북해도 골프 견적 샘플
        </a>
      </div>
    </aside>
  );
}

function EliteGolfExperienceHero() {
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setActiveSlide((current) => (current + 1) % eliteHeroSlides.length);
    }, 3000);

    return () => window.clearInterval(intervalId);
  }, []);

  return (
    <section className="relative min-h-[560px] overflow-hidden bg-[#15391f] md:min-h-[620px]">
      <div className="absolute inset-0">
        {eliteHeroSlides.map((slide, index) => (
          <img
            key={slide.src}
            src={slide.src}
            alt={slide.alt}
            className={`absolute inset-0 h-full w-full scale-105 object-cover transition-opacity duration-1000 ease-in-out ${
              index === activeSlide ? "opacity-100" : "opacity-0"
            }`}
          />
        ))}
      </div>
      <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(1,38,31,0.35)_0%,rgba(1,38,31,0.18)_48%,rgba(1,38,31,0.72)_100%)]" />
      <div className="relative z-10 mx-auto flex min-h-[560px] max-w-7xl flex-col items-center justify-center px-5 py-20 text-center text-white md:min-h-[620px] md:px-8">
        <p className="text-xs font-900 uppercase tracking-normal text-[#ffd166] md:text-sm">The Essence of Excellence</p>
        <h1 className="mt-5 text-5xl font-900 leading-tight [word-break:keep-all] md:text-7xl">
          골프는 인생이다
        </h1>
        <p className="mt-5 max-w-3xl text-base leading-8 text-white/88 [word-break:keep-all] md:text-lg">
          <span className="block">단순한 라운드를 넘어, 좋은 사람과 좋은 코스가 오래 남는 여행이 되도록</span>
          <span className="block">스페셜 투어가 일본 골프일정을 품격 있게 설계합니다.</span>
        </p>
        <div className="mt-8 flex w-full max-w-xl flex-col gap-3 sm:flex-row sm:justify-center">
          <a
            href={kakaoInquiryUrl}
            className="inline-flex min-h-12 items-center justify-center gap-2 rounded-lg bg-[#15391f] px-7 text-sm font-900 text-white ring-1 ring-[#d5c38a] transition hover:bg-[#1e542e]"
          >
            카카오톡 견적문의
            <ChatBubbleOutlineIcon sx={{ fontSize: 18 }} />
          </a>
          <a
            href={estimateSamplePdf}
            target="_blank"
            rel="noreferrer"
            className="inline-flex min-h-12 items-center justify-center gap-2 rounded-lg bg-white/12 px-7 text-sm font-900 text-white ring-1 ring-white/40 backdrop-blur-sm transition hover:bg-white hover:text-[#15391f]"
          >
            견적 샘플 보기
            <PictureAsPdfOutlinedIcon sx={{ fontSize: 18 }} />
          </a>
        </div>
        <div className="mt-10 flex items-center justify-center gap-3">
          {eliteHeroSlides.map((slide, index) => (
            <span
              key={slide.src}
              className={`h-[2px] rounded-full transition-all duration-500 ${
                index === activeSlide ? "w-14 bg-white" : "w-8 bg-white/35"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

function ProductGallery() {
  return (
    <div className="rounded-lg border border-[#d9ded5] bg-white p-4 shadow-sm">
      <img
        src={productImages[0].src}
        alt={productImages[0].alt}
        className="h-[300px] w-full rounded-lg object-cover md:h-[430px]"
      />
      <div className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-5">
        {productImages.map((image) => (
          <a key={image.label} href={`#${image.label}`} className="group block">
            <img
              src={image.src}
              alt={image.alt}
              className="h-20 w-full rounded-lg border border-[#e1e6dc] object-cover transition group-hover:border-[#1e6b34]"
            />
            <span className="mt-2 block text-center text-xs font-800 text-[#596559]">{image.label}</span>
          </a>
        ))}
      </div>
    </div>
  );
}

function ProductFacts() {
  return (
    <div className="grid gap-3 md:grid-cols-4">
      {productFacts.map((item) => (
        <div key={item.label} className="rounded-lg border border-[#d9ded5] bg-white p-5 text-center shadow-sm">
          <div className="mx-auto mb-3 flex h-11 w-11 items-center justify-center rounded-lg bg-[#e8f2e6] text-[#1e6b34]">
            {item.icon}
          </div>
          <div className="text-sm font-800 text-[#697469]">{item.label}</div>
          <div className="mt-1 text-lg font-900 text-[#15391f]">{item.value}</div>
        </div>
      ))}
    </div>
  );
}

function InquiryBanner() {
  return (
    <div className="rounded-lg border border-[#d9ded5] bg-[#15391f] p-6 text-white shadow-sm md:p-8">
      <div className="grid gap-6 lg:grid-cols-[1fr_1.25fr] lg:items-center">
        <div>
          <p className="text-sm font-900 uppercase tracking-normal text-[#ffd166]">Custom Golf Tour</p>
          <h2 className="mt-2 text-3xl font-900 leading-tight">원하는 시기와 기간을 알려주시면 맞춤 설계합니다</h2>
          <p className="mt-4 text-sm leading-7 text-white/75">
            골프만 실컷 치고 싶은 팀, 자유여행을 함께 넣고 싶은 팀, 일부만 라운드하는 단체팀까지 상담 가능합니다.
          </p>
        </div>
        <div className="grid gap-4 md:grid-cols-2">
          <a href={phoneUrl} className="rounded-lg bg-white p-5 text-[#15391f] transition hover:bg-[#f7f5ef]">
            <PhoneOutlinedIcon />
            <div className="mt-3 text-lg font-900">전화문의</div>
            <p className="mt-2 text-sm leading-6 text-[#596559]">빠른 상담이 필요할 때 바로 연결하세요.</p>
          </a>
          <a href={kakaoInquiryUrl} className="rounded-lg bg-[#FEE500] p-5 text-[#1b1600] transition hover:bg-[#f3db00]">
            <ChatBubbleOutlineIcon />
            <div className="mt-3 text-lg font-900">카톡문의</div>
            <p className="mt-2 text-sm leading-6 text-[#4a4211]">날짜, 지역, 인원만 남겨도 상담이 시작됩니다.</p>
          </a>
        </div>
      </div>
    </div>
  );
}

function OptionTable() {
  return (
    <div className="overflow-hidden rounded-lg border border-[#d9ded5] bg-white shadow-sm">
      {[
        { title: "포함 안내", items: includedItems, color: "text-[#1e6b34]" },
        { title: "불포함 안내", items: excludedItems, color: "text-[#d16339]" },
        { title: "참고사항", items: noticeItems, color: "text-[#415047]" },
      ].map((row) => (
        <div key={row.title} className="grid border-b border-[#edf0ea] last:border-b-0 md:grid-cols-[190px_1fr]">
          <div className="flex items-center bg-[#f7f5ef] px-5 py-4 text-lg font-900 text-[#15391f]">{row.title}</div>
          <div className="grid gap-2 px-5 py-4">
            {row.items.map((item) => (
              <div key={item} className="flex gap-2 text-sm leading-7 text-[#596559]">
                <CheckCircleOutlineIcon className={row.color} sx={{ fontSize: 18, marginTop: "4px", flexShrink: 0 }} />
                <span>{item}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

function TabMenu() {
  return (
    <div className="sticky top-[104px] z-30 border-y border-[#d9ded5] bg-white/95 backdrop-blur md:top-16">
      <Inner>
        <div className="flex overflow-x-auto">
          {tabs.map((tab) => (
            <a
              key={tab.href}
              href={tab.href}
              className="min-w-[120px] border-r border-[#edf0ea] px-4 py-4 text-center text-sm font-900 text-[#15391f] transition hover:bg-[#e8f2e6]"
            >
              {tab.label}
            </a>
          ))}
        </div>
      </Inner>
    </div>
  );
}

export function SpecialTourHomePage() {
  return (
    <SpecialTourLayout>
      <EliteGolfExperienceHero />

      <ContentBand className="bg-[#f7f5ef] pb-8 pt-8">
        <Inner>
          <div className="mb-4 text-sm font-800 text-[#697469]">홈 &gt; 일본골프 &gt; 스페셜투어 맞춤상품</div>
          <div className="grid gap-6 lg:grid-cols-[1fr_420px]">
            <ProductGallery />
            <ProductSummary />
          </div>
          <div className="mt-5">
            <ProductFacts />
          </div>
        </Inner>
      </ContentBand>

      <ContentBand className="bg-white pt-6">
        <Inner>
          <InquiryBanner />
        </Inner>
      </ContentBand>

      <TabMenu />

      <ContentBand id="schedule" className="scroll-mt-36 bg-[#f7f5ef]">
        <Inner>
          <SectionHeader
            eyebrow="Schedule"
            title="지역별 기본 일정표"
            body="참고 사이트처럼 상품 상세 흐름에서 바로 확인할 수 있도록 대표 일정을 한 화면에 정리했습니다."
          />
          <div className="grid gap-5">
            {itineraries.map((itinerary) => (
              <article
                id={itinerary.slug}
                key={itinerary.slug}
                className="overflow-hidden rounded-lg border border-[#d9ded5] bg-white shadow-sm"
              >
                <div className="grid gap-4 border-b border-[#edf0ea] bg-[#15391f] px-5 py-4 text-white md:grid-cols-[220px_1fr]">
                  <div className="text-xl font-900">{itinerary.region}</div>
                  <div>
                    <div className="text-lg font-900">{itinerary.title}</div>
                    <div className="mt-1 text-sm text-white/72">{itinerary.subtitle}</div>
                  </div>
                </div>
                <div className="divide-y divide-[#edf0ea]">
                  {itinerary.days.map((day, index) => (
                    <div key={day} className="grid gap-3 px-5 py-4 md:grid-cols-[120px_1fr]">
                      <div className="font-900 text-[#d16339]">{index + 1}일차</div>
                      <div className="text-sm font-700 leading-7 text-[#3d4a41]">{day.replace(/^[^:]+:\s*/, "")}</div>
                    </div>
                  ))}
                </div>
              </article>
            ))}
          </div>
        </Inner>
      </ContentBand>

      <ContentBand id="details" className="scroll-mt-36 bg-white">
        <Inner>
          <SectionHeader
            eyebrow="Detail"
            title="상품 상세정보"
            body="가격을 먼저 고정하지 않고, 출발일과 인원에 따라 필요한 요소를 조합해 견적을 냅니다."
          />
          <div className="grid gap-8 lg:grid-cols-[1fr_360px]">
            <OptionTable />
            <div className="rounded-lg border border-[#d9ded5] bg-[#fbfaf6] p-6 shadow-sm">
              <h3 className="text-2xl font-900 text-[#15391f]">추천 상담 순서</h3>
              <div className="mt-5 grid gap-4">
                {[
                  ["1", "지역과 날짜 선택"],
                  ["2", "인원과 라운드 수 확인"],
                  ["3", "호텔, 차량, 자유여행 조정"],
                  ["4", "카톡으로 최종 견적 안내"],
                ].map(([step, text]) => (
                  <div key={step} className="grid grid-cols-[42px_1fr] gap-3">
                    <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-[#e8f2e6] font-900 text-[#1e6b34]">
                      {step}
                    </span>
                    <span className="self-center text-sm font-800 text-[#3d4a41]">{text}</span>
                  </div>
                ))}
              </div>
              <div className="mt-6">
                <KakaoButton label="상세 견적 문의" />
              </div>
            </div>
          </div>
        </Inner>
      </ContentBand>

      <ContentBand id="courses" className="scroll-mt-36 bg-[#f7f5ef]">
        <Inner>
          <div className="mb-8 flex flex-col justify-between gap-4 md:flex-row md:items-end">
            <SectionHeader
              eyebrow="Golf Courses"
              title="골프장 소개"
              body="지역별 대표 이미지와 코스 분위기를 먼저 보고 상담을 시작할 수 있습니다."
            />
            <Link to="/courses" className="text-sm font-900 text-[#1d5d31] hover:text-[#15391f]">
              골프장 전체 보기
            </Link>
          </div>
          <div className="grid gap-5 md:grid-cols-2 xl:grid-cols-3">
            {courseGallery.slice(0, 8).map((course) => (
              <article key={course.title} className="overflow-hidden rounded-lg border border-[#d9ded5] bg-white shadow-sm">
                <img src={course.image} alt={course.imageAlt} className="h-52 w-full object-cover" />
                <div className="p-5">
                  <div className="text-sm font-900 text-[#d16339]">{course.region}</div>
                  <h3 className="mt-2 text-xl font-900 text-[#15391f]">{course.title}</h3>
                  <p className="mt-3 text-sm leading-7 text-[#596559]">{course.description}</p>
                </div>
              </article>
            ))}
          </div>
        </Inner>
      </ContentBand>

      <ContentBand id="stay" className="scroll-mt-36 bg-white">
        <Inner>
          <div className="mb-8 flex flex-col justify-between gap-4 md:flex-row md:items-end">
            <SectionHeader
              eyebrow="Stay & Travel"
              title="호텔, 온천, 자유여행까지 함께 설계"
              body="여행상품 상세 페이지의 호텔/리조트 소개 흐름을 스페셜투어에 맞게 목적지 중심으로 재구성했습니다."
            />
            <Link to="/hotels" className="text-sm font-900 text-[#1d5d31] hover:text-[#15391f]">
              숙소 상세 보기
            </Link>
          </div>
          <div className="grid gap-5 md:grid-cols-3">
            {[
              {
                icon: <HotelOutlinedIcon />,
                title: "숙박",
                body: "지역과 라운드 순서에 맞춰 이동 부담이 적은 숙소를 상담합니다.",
              },
              {
                icon: <DirectionsCarOutlinedIcon />,
                title: "차량",
                body: "공항, 호텔, 골프장, 저녁 동선이 끊기지 않도록 이동 계획을 세웁니다.",
              },
              {
                icon: <LocalDiningOutlinedIcon />,
                title: "식사",
                body: "클럽식, 현지 맛집, 이자카야 등 팀 성향에 맞는 식사 정보를 제안합니다.",
              },
            ].map((item) => (
              <div key={item.title} className="rounded-lg border border-[#d9ded5] bg-[#fbfaf6] p-6 shadow-sm">
                <div className="mb-4 inline-flex h-11 w-11 items-center justify-center rounded-lg bg-[#e8f2e6] text-[#1e6b34]">
                  {item.icon}
                </div>
                <h3 className="text-xl font-900 text-[#15391f]">{item.title}</h3>
                <p className="mt-3 text-sm leading-7 text-[#596559]">{item.body}</p>
              </div>
            ))}
          </div>
          <div className="mt-8 grid gap-5 md:grid-cols-3">
            {destinations.slice(0, 5).map((destination) => (
              <article key={destination.title} className="overflow-hidden rounded-lg border border-[#d9ded5] bg-[#fbfaf6] shadow-sm">
                <img src={destination.image} alt={destination.imageAlt} className="h-48 w-full object-cover" />
                <div className="p-5">
                  <div className="text-sm font-900 text-[#d16339]">{destination.area}</div>
                  <h3 className="mt-2 text-xl font-900 text-[#15391f]">{destination.title}</h3>
                  <p className="mt-3 text-sm leading-7 text-[#596559]">{destination.description}</p>
                </div>
              </article>
            ))}
          </div>
        </Inner>
      </ContentBand>

      <ContentBand id="reviews" className="scroll-mt-36 bg-[#f7f5ef]">
        <Inner>
          <SectionHeader
            eyebrow="Reviews & Inquiry"
            title="후기와 문의"
            body="공개 가능한 리뷰를 보여주고, 상담은 카카오톡 링크로 바로 이어집니다."
          />
          <div className="grid gap-6 lg:grid-cols-[1fr_390px]">
            <div className="grid gap-4">
              {reviews.map((review) => (
                <article key={review.title} className="rounded-lg border border-[#d9ded5] bg-white p-5 shadow-sm">
                  <div className="flex flex-wrap gap-2 text-xs font-900 text-[#d16339]">
                    <span>{review.date}</span>
                    <span>{review.people}</span>
                    <span>{review.rating}</span>
                  </div>
                  <h3 className="mt-2 text-xl font-900 text-[#15391f]">{review.title}</h3>
                  <p className="mt-3 text-sm leading-7 text-[#596559]">{review.body}</p>
                </article>
              ))}
            </div>
            <div className="rounded-lg border border-[#d9ded5] bg-white p-6 shadow-sm">
              <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-[#e8f2e6] text-[#1e6b34]">
                <PaymentsOutlinedIcon />
              </div>
              <h3 className="text-2xl font-900 text-[#15391f]">견적은 카톡에서 확정됩니다</h3>
              <p className="mt-4 text-sm leading-7 text-[#596559]">
                홈페이지의 가격은 고정 상품가가 아니라 상담 기준입니다. 날짜와 인원에 맞춰 가능한 골프장, 차량,
                숙소를 확인한 뒤 최종 견적을 안내합니다.
              </p>
              <div className="mt-6">
                <QuickContactBar />
              </div>
            </div>
          </div>
        </Inner>
      </ContentBand>
    </SpecialTourLayout>
  );
}
